<template>
  <label class="block relative cursor-pointer">
    <input
      ref="input"
      :value="value"
      type="text"
      :disabled="disabled"
      class="absolute inset-0 w-full h-full opacity-0"
      @focus="focused = true"
      @blur="focused = false"
      @keydown="filterKeypress"
    >
    <span class="relative font-mc select-none flex">
      <span
        v-for="n of len"
        :key="n"
        :class="[
          'flex-none w-12 h-16 ml-2 first:ml-0 text-4xl border-2 flex items-center justify-center transition duration-100 ease-linear',
          disabled ? 'bg-gray-50' : 'bg-white',
          focused && (value.length + 1 === n || (value.length === len && n === len)) ? 'border-green-500' : 'border-gray-300',
          {'animated': animation},
        ]"
        :style="{animationDelay: (n - 1) * 100 + 'ms'}"
      >
        {{ value[n - 1] }}
      </span>
    </span>
  </label>
</template>

<script>
  import {ref} from '@vue/composition-api'

  const NUMERIC_KEYS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']

  export default {
    name: 'PinInput',

    props: {
      value: {
        type: String,
        default: '',
      },

      len: {
        type: Number,
        default: 6,
      },

      disabled: {
        type: Boolean,
        default: false,
      },

      animation: {
        type: Boolean,
        default: false,
      },
    },

    setup (props, {emit}) {
      /** @type {{value: HTMLInputElement}} */
      const input = ref(null)
      const focused = ref(false)

      function focus () {
        input.value.focus()
      }

      function filterKeypress (/** @type {KeyboardEvent} */ {key}) {
        if (NUMERIC_KEYS.includes(key) && props.value.length < props.len) {
          emit('input', props.value + key)
        } else if (key === 'Backspace') {
          emit('input', props.value.slice(0, -1))
        } else if (key === 'Escape') {
          emit('input', '')
        }
      }

      return {
        input,
        focused,

        focus,
        filterKeypress,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .animated {
    animation: 1.2s linear infinite fading-outline;

    @keyframes fading-outline {
      0% {
        @apply border-green-500;
      }

      50% {
        @apply border-gray-300;
      }
    }
  }
</style>
